export default "/assets/images/big-sneeze1.png?d0e42f0e558133a8ea7b0d60b13a9d5c";